/*
 * np-voluum-events.js - real funnel events into Voluum (2026-10-22, c_0af96c65de).
 *
 * Jared: "an offer click means they actually clicked on an offer on the product
 * page". Voluum's own "Clicks" column only means the visitor ARRIVED on the
 * offer page (lander CTA -> go.npgummy.com/click). This fires Voluum custom
 * conversions on the click id stored by np-vcid.js:
 *   offerclick - first tap on a package tile / plan / buy button on the PDP
 *   addtocart  - first successful add to cart (ajax /cart/add or cart has items)
 *   checkout   - first tap on a checkout control (drawer, cart, buy-now submit)
 * Purchase is NOT fired here: it already reaches Voluum as the normal
 * conversion (custom pixel 164626690 + np_voluum_conversion_sync.py, txid dedupe).
 *
 * Each event fires ONCE per click id: localStorage key np_vev:<cid>:<et>, and
 * txid=<et> so Voluum itself also dedupes a repeat (same cid + same txid).
 * Voluum types (Settings -> Custom conversions, index 6/7/8) are set to NOT
 * count in Conversions/Revenue and NOT postback to the traffic source.
 * Organic visitors (no stored cid) -> no-op. Never throws.
 */
(function () {
  'use strict';
  var PB = 'https://go.npgummy.com/postback';

  function cid() {
    var v = null;
    try { v = window.localStorage.getItem('np_vcid'); } catch (e) {}
    if (!v) {
      try {
        var m = document.cookie.match('(?:^|; )np_vcid=([^;]*)');
        v = m ? decodeURIComponent(m[1]) : null;
      } catch (e) {}
    }
    return v && !/[{}]/.test(v) ? v : null;
  }

  function fire(et) {
    try {
      var c = cid();
      if (!c) return;
      var k = 'np_vev:' + c + ':' + et;
      try { if (window.localStorage.getItem(k)) return; window.localStorage.setItem(k, String(Date.now())); } catch (e) {}
      var url = PB + '?cid=' + encodeURIComponent(c) + '&et=' + et + '&payout=0&txid=' + et;
      var sent = false;
      try { if (navigator.sendBeacon) sent = navigator.sendBeacon(url); } catch (e) {}
      if (!sent) {
        try { fetch(url, { mode: 'no-cors', keepalive: true, credentials: 'omit' }); }
        catch (e) { try { (new Image()).src = url; } catch (e2) {} }
      }
      try { (window.NP_VEV_LOG = window.NP_VEV_LOG || []).push(et); } catch (e) {}
    } catch (e) {}
  }

  var OFFER_SEL = '.np-offer-tile, .np-offer-buyonce, label.plan, .plan-radio, [data-buy-submit],' +
    ' form[action^="/cart/add"] [type=submit], a[href^="/cart/add"], .plan-nojs, .sticky-buy button,' +
    ' .sticky-buy a[href^="/cart"]';
  var CHECKOUT_SEL = 'a[href^="/checkout"], [name="checkout"], form[action^="/checkout"] [type=submit],' +
    ' .shopify-payment-button, shopify-accelerated-checkout, shop-pay-wallet-button';

  function onPdp() {
    var p = window.NP_PAGE;
    return p === 'pdp' || (p !== 'landra' && p !== 'landra2' && !/^\/pages\//.test(location.pathname));
  }

  document.addEventListener('click', function (e) {
    try {
      // 2026-10-28: ignore synthetic clicks. np-offer-render.js dispatches a plain
      // Event('click') on the default .plan tile at load for Offer A (np.js exports no
      // NPSelectPlan), which used to fire a fake offerclick with no tap.
      if (!e.isTrusted) return;
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      if (onPdp() && t.closest(OFFER_SEL)) fire('offerclick');
      if (t.closest(CHECKOUT_SEL)) fire('checkout');
      // a /cart/add GET link leaves the page before any ajax hook can see it
      if (t.closest('a[href^="/cart/add"]')) fire('addtocart');
    } catch (err) {}
  }, true);

  document.addEventListener('submit', function (e) {
    try {
      var f = e.target, a = (f && f.getAttribute('action')) || '';
      var sub = e.submitter;
      if (/^\/checkout/.test(a) || (sub && sub.name === 'checkout')) fire('checkout');
    } catch (err) {}
  }, true);

  function isAdd(u) { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; }

  try {
    var of = window.fetch;
    window.fetch = function () {
      var u = arguments[0] && (arguments[0].url || arguments[0]);
      var p = of.apply(this, arguments);
      if (isAdd(String(u))) p.then(function (r) { if (r && r.ok) fire('addtocart'); }).catch(function () {});
      return p;
    };
  } catch (e) {}
  try {
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__npAdd = isAdd(String(u)); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x.__npAdd) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) fire('addtocart'); });
      return os.apply(this, arguments);
    };
  } catch (e) {}

  // Fallback: cart already holds items (a /cart/add GET permalink landed on /cart).
  function cartCheck() {
    try {
      if (!cid()) return;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.item_count > 0) fire('addtocart'); }).catch(function () {});
    } catch (e) {}
  }
  if (document.readyState === 'complete') cartCheck(); else window.addEventListener('load', cartCheck);
})();

